<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title">
        <h5>Mobile User</h5>
    </div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form [formGroup]="volunteerForm" class="m-2">
        <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
            <div>{{errorMsg}}</div>
            <div>
                <button class="p-0 m-0 btn" (click)="errorMsg=''">
                    <i class="fa fa-times"></i>
                </button>
            </div>
        </div>

        <tabset [justified]="false">

            <tab heading="Mobile User">
                <div class="tab-content">
                    <div class="p-1">
                        <div class="label-wrapper">
                            <label class="form-label">User ID</label>
                            <label *ngIf="volunteerForm?.controls['id']?.hasError('required')"
                                class="ml-2 form-label text-danger font-italic">required</label>
                        </div>
                        <input size=70 type='id' class="form-control w-100" formControlName="id" required
                            [attr.disabled]="volunteer && volunteer.id != null" [ngClass]="{
                                'invalid-input': volunteerForm.controls['id'].invalid
                                && ( volunteerForm.controls['id'].dirty ||  volunteerForm.controls['id'].touched)
                            }" />
                    </div>
                    <div class="p-1">
                        <div class="label-wrapper">
                            <label class="form-label">Name</label>
                            <label *ngIf="volunteerForm?.controls['name']?.hasError('required')"
                                class="ml-2 form-label text-danger font-italic">required</label>
                        </div>
                        <input size="70" type="text" class="form-control w-100" formControlName="name" required
                            [ngClass]="{ 'invalid-input':  volunteerForm.controls['name'].invalid && ( volunteerForm.controls['name'].dirty ||  volunteerForm.controls['name'].touched)}">
                    </div>
                    <div class="p-1">
                        <div class="label-wrapper">
                            <label class="form-label">Email</label>
                            <label *ngIf="volunteerForm.controls['email'].errors"
                                class="ml-2 form-label text-danger font-italic">{{volunteerForm.controls['email'].errors?.required?'required':'invalid'}}</label>
                        </div>
                        <input size=70 type='email' class="form-control w-100" formControlName="email" required
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['email'].invalid && ( volunteerForm.controls['email'].dirty ||  volunteerForm.controls['email'].touched)}" />
                    </div>
                    <div class="p-1 pb-0 d-flex flex-row flex-wrap">
                        <div class="w-50 mr-2">
                            <div class="label-wrapper">
                                <label class="form-label">Password</label>
                                <label *ngIf="!volunteer && volunteerForm.controls['password'].errors?.required"
                                    class="ml-2 form-label text-danger font-italic">required</label>
                            </div>
                            <div>
                                <input size=70 type="text" class="form-control w-100" formControlName="password"
                                    [ngClass]="{ 'invalid-input':  volunteerForm.controls['password'].invalid && ( volunteerForm.controls['password'].dirty ||  volunteerForm.controls['password'].touched)}">
                                <div *ngIf="volunteer" class="font-italic small light-gray text-left">* Leave empty to
                                    keep existing password
                                </div>
                            </div>
                        </div>
                        <div class="mr-2">
                            <div class="label-wrapper">
                                <label class="form-label">Chest Height (meters)</label>
                            </div>
                            <input size=5 type='number' class="form-control" formControlName="chestHeight"
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['chestHeight'].invalid && ( volunteerForm.controls['chestHeight'].dirty ||  volunteerForm.controls['chestHeight'].touched)}" />
                        </div>
                        <div class="mr-2">
                            <div class="label-wrapper">
                                <label class="form-label">Status</label>
                            </div>
                            <select class="form-control w-100" formControlName="status" required
                                [ngClass]="'user-status-default user-status-'+volunteerForm.controls['status'].value">
                                <option *ngFor="let status of ['active','verified','pending','locked']"
                                    [ngValue]="status" [ngClass]="'user-status-default user-status-'+status">
                                    {{status|titlecase}}</option>
                            </select>
                            <span *ngIf="volunteerForm.controls['status'].invalid"
                                class="text-danger small font-italic">* Required</span>
                        </div>

                    </div>
                    <div class="p-1 pb-0 d-flex flex-row">
                        <div class="pt-0 p-1">
                            <div class="label-wrapper">
                                <label class="form-label">City</label>
                                <label *ngIf="volunteerForm.controls['city']?.hasError('required')"
                                    class="ml-2 form-label text-danger font-italic">required</label>
                            </div>
                            <input size=70 type='text' class="form-control w-100" formControlName="city" required
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['city'].invalid && ( volunteerForm.controls['city'].dirty ||  volunteerForm.controls['city'].touched)}" />
                        </div>
                        <div class="p-1">
                            <div class="label-wrapper">
                                <label class="form-label">State:</label>
                            </div>
                            <input size=70 type='text' class="form-control w-100" autocomplete="false"
                                formControlName="state"
                                [ngClass]="{ 'invalid-input':  volunteerForm.controls['state'].invalid && ( volunteerForm.controls['state'].dirty ||  volunteerForm.controls['state'].touched)}">
                        </div>
                    </div>
                    <div class="p-1 pb-0 d-flex flex-row">
                        <div class="p-1  w-100">
                            <div class="label-wrapper">
                                <label class="form-label">Volunteer Building</label>
                                <label *ngIf="volunteerForm.controls['volunteerBuildingId'].errors?.required"
                                    class="ml-2 form-label text-danger font-italic">required</label>
                            </div>
                            <select class="form-control w-100" formControlName="volunteerBuildingId" required
                                (change)="onVolunteerBuildingIdChange()"
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['volunteerBuildingId'].invalid && (volunteerForm.controls['volunteerBuildingId'].dirty || volunteerForm.controls['volunteerBuildingId'].touched)}">
                                <option *ngFor="let buildingInfo of buildingInfoArray" [ngValue]="buildingInfo.id">
                                    {{buildingInfo.id}} - {{buildingInfo.name}}</option>
                            </select>
                        </div>
                        <div class="p-1" title="Enable debug log messages from handset or testbed">
                            <div class="label-wrapper">
                                <label class="form-label">Debug:</label>
                            </div>
                            <input type='checkbox' class="my-1 form-control w-100" formControlName="debug">
                        </div>
                    </div>

                    <div class="p-1">
                        <label class="form-label">Notes:</label>
                        <textarea formControlName="notes" rows="3" class="w-100"
                            style="resize: both; border-radius:0.5rem"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['notes'].invalid && (volunteerForm.controls['notes'].dirty || volunteerForm.controls['notes'].touched)}"></textarea>
                    </div>

                </div>
            </tab>
            <tab heading="Points">
                <div class="tab-content">
                    <div class="p-1  w-100">
                        <label class="form-label">Building:</label>
                        <select class="form-control w-100" formControlName="buildingId" (change)="onBuildingIdChanged()"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['buildingId'].invalid && (volunteerForm.controls['buildingId'].dirty || volunteerForm.controls['buildingId'].touched)}">
                            <option *ngFor="let buildingInfo of buildingInfoArray" [ngValue]="buildingInfo.id">
                                {{buildingInfo.id}} - {{buildingInfo.name}}</option>
                        </select>
                        <span *ngIf="volunteerForm.controls['buildingId'].invalid"
                            class="text-danger small font-italic">* Invalid
                        </span>
                    </div>
                    <div class="p-1 w-100">
                        <label class="form-label">Path:</label>
                        <select class="form-control" formControlName="pathId" (ngModelChange)="onPathIdChanged($event)"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['pathId'].invalid && (volunteerForm.controls['pathId'].dirty || volunteerForm.controls['pathId'].touched)}">
                            <option *ngFor="let pathId of pathIds" [ngValue]="pathId">
                                {{pathId}}
                            </option>
                        </select>
                        <!-- If just deleting existing accessible points, we should not need to select a path??? -->
                        <!--span *ngIf="volunteerForm.controls['pathId'].invalid"
                              class="text-danger small font-italic">* Required</span-->
                    </div>
                    <div class="card p-1 mt-3 w-100">
                        <div class="p-1">
                            <div class="d-flex flex-row card-title justify-content-between">
                                <div>Test Points:</div>
                            </div>
                            <ng-container *ngIf="!pointIds?.length">
                                <ng-container *ngIf="volunteerForm.value.pathId; else selectPathId">
                                    <div *ngIf="pathPtsInitProcessing" class="small text-secondary font-italic">
                                        <i class="fa fa-spinner fa-spin text-secondary small mr-2"></i>
                                        Loading points for {{volunteerForm.value.pathId}}...
                                    </div>
                                    <div *ngIf="!pathPtsInitProcessing" class="small text-danger font-italic">
                                        No points found for {{volunteerForm.value.pathId}}
                                    </div>
                                </ng-container>
                                <ng-template #selectPathId>
                                    <div class="small text-muted font-italic">* Please select a Path ID</div>
                                </ng-template>
                            </ng-container>
                            <ng-container>
                                <div *ngFor="let pointId of pointIds; index as index;" class="badge m-1"
                                    [tooltip]="descriptions[pointId]"
                                    [attr.role]="canToggleByStatusId[statusByPointId[pointId]]?'button':''"
                                    [ngClass]="statusByPointId[pointId]|taskStatusCss"
                                    (click)="toggleNotUsing(pointId)">
                                    #{{index + 1}}: {{pointId}}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="card p-1 mt-3 w-100">
                        <div class="p-1">
                            <div class="d-flex flex-row card-title justify-content-between">
                                <div>Accessible Points:</div>
                            </div>
                            <ng-container>
                                <div *ngFor="let accessiblePointId of accessiblePointIds; index as index;"
                                    class="badge m-1" [attr.role]="'button'" [ngClass]="'status-complete'">
                                    #{{index + 1}}: {{accessiblePointId}}
                                    <span class="badge badge-danger"
                                        (click)="toggleNotUsing(accessiblePointId)">X</span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </tab>
            <tab heading="Handset">
                <div class="tab-content">
                    <div class="d-flex flex-row mb-1">
                        <div class="p-1 mr-2 w-50">
                            <label class="form-label">Number:</label>
                            <input size=70 type='text' class="form-control w-100" formControlName="number"
                                pattern="^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$"
                                (keyup)="onInputChange($event)" (keydown)="onInputChange($event)"
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['number'].invalid && ( volunteerForm.controls['number'].dirty ||  volunteerForm.controls['number'].touched)}" />
                            <span *ngIf="volunteerForm.controls['number'].errors?.['pattern']"
                                class="text-danger small font-italic">* ex. (111)111-1111</span>

                        </div>
                        <div class="p-1 w-50">
                            <label class="form-label">Device ID:</label>
                            <div class="d-flex flex-row">
                                <input size=70 type='text' class="form-control w-100" readonly
                                    [value]="volunteer?.['deviceId']" />
                                <button *ngIf="volunteer?.['deviceId']" (click)="resetDeviceId()"
                                class="ml-1 btn btn-sm btn-warning px-1 py-0">
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row mb-1">
                        <div class="p-1 mr-2 w-50">
                            <label class="form-label">IMEI:</label>
                            <input size=70 type='text' class="form-control w-100" formControlName="imei"
                                pattern="^[0-9]{15,15}|[,]$"
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['imei'].invalid && ( volunteerForm.controls['imei'].dirty ||  volunteerForm.controls['imei'].touched)}" />
                            <span *ngIf="volunteerForm.controls['imei'].errors?.['pattern']"
                                class="text-danger small font-italic">* IMEI should contain minimum 15 digits</span>

                        </div>
                        <div class="p-1 w-50">
                            <label class="form-label">BT MAC:</label>
                            <input size=70 type='text' class="form-control w-100" formControlName="bt_mac"
                                pattern="^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$"
                                [ngClass]="{ 'invalid-input': volunteerForm.controls['bt_mac'].invalid && ( volunteerForm.controls['bt_mac'].dirty ||  volunteerForm.controls['bt_mac'].touched)}" />
                            <span *ngIf="volunteerForm.controls['bt_mac'].errors?.['pattern']"
                                class="text-danger small font-italic">* Required MAC XX:XX:XX:XX:XX:XX</span>

                        </div>
                    </div>
                    <div class="p-1  w-100">
                        <label class="form-label">Carrier:</label>
                        <input size=70 type='text' class="form-control w-100" formControlName="carrier"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['carrier'].invalid && ( volunteerForm.controls['carrier'].dirty ||  volunteerForm.controls['carrier'].touched)}" />
                    </div>
                    <div class="p-1  w-100">
                        <label class="form-label">Make:</label>
                        <input size=70 type='text' class="form-control w-100" formControlName="make"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['make'].invalid && ( volunteerForm.controls['make'].dirty ||  volunteerForm.controls['make'].touched)}" />
                    </div>
                    <div class="p-1  w-100">
                        <label class="form-label">Model:</label>
                        <input size=70 type='model' class="form-control w-100" formControlName="model"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['model'].invalid && ( volunteerForm.controls['model'].dirty ||  volunteerForm.controls['model'].touched)}" />
                    </div>
                    <div class="p-1  w-100">
                        <label class="form-label">OS:</label>
                        <select name="os" class="form-control w-100" formControlName="os"
                            [ngClass]="{ 'invalid-input': volunteerForm.controls['os'].invalid && (volunteerForm.controls['os'].dirty || volunteerForm.controls['os'].touched)}">
                            <option>iOS</option>
                            <option>Android</option>
                        </select>
                    </div>
                </div>
            </tab>
        </tabset>
    </form>
</div>
<div class="modal-footer">
    <div class="d-flex flex-row justify-content-between w-100 px-1">
        <div class="d-flex flex-column justify-content-center small text-sm">
            <div class="text-secondary font-italic" *ngIf="modifiedBy$|async as modifiedByName">
                Last modified by {{modifiedByName}} ({{volunteer.modifiedAt|date:'short'}})
            </div>
            <div *ngIf="volunteerForm.invalid" class="text-danger font-italic">* Required or invalid entries on one or
                more tabs</div>
        </div>
        <div>
            <button (click)="onSave()" [disabled]="volunteerForm.pristine || volunteerForm.invalid"
                class="btn btn-primary">
                Save
            </button>
            <button (click)="onCancel()" class="btn btn-secondary ml-2">Cancel</button>
        </div>
    </div>
</div>